import { render, staticRenderFns } from "./_footer.vue?vue&type=template&id=f35b3640&scoped=true"
import script from "./_footer.vue?vue&type=script&lang=js"
export * from "./_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35b3640",
  null
  
)

export default component.exports